import * as Sentry from "@sentry/vue";
import { createPinia } from "pinia";
import { createApp } from "vue";

import "@/style.css";
import App from "@/App.vue";
import router from "@/router.js";

export const pinia = createPinia();

const app = createApp(App).use(router).use(pinia);
app.mount("#app");

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    app,
    dsn: "https://520b555d23d72a16884116e9acbc1d39@o198392.ingest.us.sentry.io/4510551217930240",
    sendDefaultPii: true,
    integrations: [
      Sentry.httpClientIntegration({
        failedRequestStatusCodes: [
          [400, 402], // lets ignore 403 errors
          [404, 499],
          [500, 599],
        ],
      }),
    ],
  });
  pinia.use(Sentry.createSentryPiniaPlugin());
}
